export interface CompanySetupCounts { sites: number; total: number; ready: number }

/** Never present malformed or unavailable counts as zero/complete. */
export function companySetupCounts(value: unknown): CompanySetupCounts {
  if (!value || typeof value !== 'object' || !('sites' in value) || !('total' in value) || !('ready' in value)) {
    throw new Error('invalid_company_setup_counts');
  }
  const { sites, total, ready } = value;
  if (typeof sites !== 'number' || typeof total !== 'number' || typeof ready !== 'number'
    || ![sites, total, ready].every((count) => Number.isSafeInteger(count) && count >= 0) || ready > total) {
    throw new Error('invalid_company_setup_counts');
  }
  return { sites, total, ready };
}
